import {constant, find} from 'lodash/fp';

import {
  complete,
  completeStep,
  CONTINUE_SEQUENCE,
} from '/redux/action/launchSequence.action';

import fetchAuthEmailTask from './task/fetchAuthEmail';
import fetchInitialDataTask from './task/fetchInitialData';
import fetchLoggedInUserTask from './task/fetchLoggedInUser';
import {fetchRecentSearchesTask} from './task/fetchRecentSeacrhes';
import {fetchRemoteConfigTask} from './task/fetchRemoteConfig';
import fetchTestingOptionsTask from './task/fetchTestingOptions';

// Tasks defined in this array will be checked and performed
// in the same order as they are defined.
const ALL_TASKS = [
  fetchLoggedInUserTask,
  fetchInitialDataTask,
  fetchAuthEmailTask,
  fetchTestingOptionsTask,
  fetchRemoteConfigTask,
  fetchRecentSearchesTask,
];

export default ({dispatch, getState}: any) =>
  (next: any) =>
  (action: any) => {
    const {type: actionType} = action;
    const oldState = getState();

    return Promise.resolve(next(action)).then(() => {
      const taskPayload = {dispatch, state: oldState};

      if (actionType === CONTINUE_SEQUENCE) {
        // Find the first incomplete task from the list of all tasks.
        const task = find(({isCompleted}: any) => !isCompleted(taskPayload))(
          ALL_TASKS,
        );

        if (task) {
          return (
            task
              // Perform the task.
              .perform(taskPayload)
              // Launch sequence task can not really "fail" as any failures must be handled
              // internally within the task. So here we intentionally ignore any errors from
              // the task's promise, and then ...
              .catch(constant(undefined))
              // ... mark the step as completed.
              .then(() => dispatch(completeStep({stepName: task.stepName})))
          );
        } else {
          // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
          return dispatch(complete());
        }
      }
    });
  };
